export default [{
  path: '/dashboard',
  name: 'dashboard',
  component: () => import('@/views/apps/dashboard/index.vue'),
}]